/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	SimpleViewStudentDTO,
	SimpleViewStudentDTOFromJSON,
	SimpleViewStudentDTOFromJSONTyped,
	SimpleViewStudentDTOToJSON,
} from "./SimpleViewStudentDTO";

/**
 *
 * @export
 * @interface SimpleViewStudentDTOPagedResponse
 */
export interface SimpleViewStudentDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof SimpleViewStudentDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof SimpleViewStudentDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof SimpleViewStudentDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<SimpleViewStudentDTO>}
	 * @memberof SimpleViewStudentDTOPagedResponse
	 */
	data?: Array<SimpleViewStudentDTO> | null;
}

export function SimpleViewStudentDTOPagedResponseFromJSON(
	json: any
): SimpleViewStudentDTOPagedResponse {
	return SimpleViewStudentDTOPagedResponseFromJSONTyped(json, false);
}

export function SimpleViewStudentDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): SimpleViewStudentDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(SimpleViewStudentDTOFromJSON),
	};
}

export function SimpleViewStudentDTOPagedResponseToJSON(
	value?: SimpleViewStudentDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(SimpleViewStudentDTOToJSON),
	};
}
